export const ActionTypes = {
  FETCH_ALL_PRODUCTS: "FETCH_ALL_PRODUCTS",
  FETCH_SELECTED_PRODUCT: "FETCH_SELECTED_PRODUCT",
  REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
};
